
import { Component, Vue } from "vue-property-decorator";
import ButtonAction from "@/components/buttons/Button.vue";
import { toast } from "@/store";
import { TYPE } from "@/store/modules/toast.module";
import LoginService from "@/services/login.service";
import { LocalStorageApp } from "@/utils/localstorage";
import { JwtManage } from "@/utils/jwt";
import { User } from "@/models";
import { isPasswordStrong } from "@/helpers";

/**
 * "Unlock session" screen (route `/deverrouiller`) — re-authenticates a user whose token is present
 * but expired, via password or a Slack one-time code, without re-typing the username.
 */
@Component({
  components: { ButtonAction },
})
export default class Login extends Vue {
  private ready = false;
  private context: User | null = null;
  private username = "";
  private userpasswd = "";
  private useOTP = false;

  private backgroundImage = {
    backgroundImage: `url(${require("@/assets/images/photos/IMG_5378.jpg")})`,
  };

  async mounted(): Promise<void> {
    const token: string = LocalStorageApp.getItem("pcp.token") ?? "";
    const tokenValue = JwtManage.decode(token);
    this.username = tokenValue?.user_username ?? "";
    if (tokenValue) {
      this.context = (await LoginService.contextUnlock(token)) ?? null;
      this.ready = true;
    } else {
      this.goToLogin();
    }
  }

  /** Redirects to the full login screen, prompting for account switch. */
  private goToLogin() {
    this.$router.push({
      path: "/connexion",
      query: { ...this.$route.query, change_compte: "true" },
    });
  }

  /** Requests a one-time login code sent via Slack, switching the form to OTP mode. */
  private async receiveCodeSlack() {
    if (this.username) {
      if (await LoginService.codeSlack(this.username)) {
        this.useOTP = true;
      }
    }
  }

  private updatePasswd(input: number) {
    this.userpasswd = input as unknown as string;
  }

  /** Submits the password or OTP code to re-authenticate. */
  private async login() {
    if (this.username && this.userpasswd) {
      if (await LoginService.login(this.username, this.userpasswd)) {
        const go = this.$route.query.go as string | undefined;
        const passwordWeak = !this.useOTP && !isPasswordStrong(this.userpasswd);
        if (!this.useOTP) {
          LocalStorageApp.setItem("pcp.mustChangePassword", passwordWeak);
        }
        if (passwordWeak) {
          this.$router.replace(
            go
              ? `/securiser-mot-de-passe?go=${encodeURIComponent(go)}`
              : "/securiser-mot-de-passe"
          );
        } else {
          this.$router.replace(go || "/");
        }
      } else {
        this.userpasswd = "";
      }
    } else {
      toast.createAndPushToast(
        "Veuillez saisir un nom d'utilisateur et un mot de passe",
        "",
        true,
        TYPE.INFO
      );
    }
  }
}
